import PurchaseOptions from '@r1-frontend/ui-react/components/costs/PurchaseOptions';
import { TBaseOption } from '@r1-frontend/ui-react/components/costs/PurchaseOptions/types';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { FullWidthListContainer, IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { ScrollbarWithIndent } from '@r1-frontend/ui-react/organisms/ScrollbarWithIndent';

import { IPreparedRouter } from '~/src/entities/speed-bonus/context/actions/setRouters';

import RouterCharacteristics from './components/RouterCharacteristics';
import RouterImages from './components/RouterImages';

interface IProps {
    isPopupOpen: boolean,
    onClose: () => void,
    onSelect: (cost: number) => void,
    title: string,
    images: string[],
    routerProps: IPreparedRouter['props'],
    routerOptions:  Record<number, TBaseOption>,
}

const AddRouterPopup = ({
    isPopupOpen,
    onClose,
    onSelect,
    title,
    images,
    routerProps,
    routerOptions,
}: IProps): JSX.Element => {
    return (
        <DefaultPopup isOpen={isPopupOpen} onClose={onClose}>
            <IndentContainer $desktop={[32]} $mobile={[24]}>
                <H3>{title}</H3>

                <ScrollbarWithIndent>
                    <FullWidthListContainer $desktop={24} $mobile={16}>
                        <RouterImages images={images}/>

                        <RouterCharacteristics characteristics={routerProps}/>

                        <PurchaseOptions options={routerOptions} onSelect={onSelect}/>
                    </FullWidthListContainer>
                </ScrollbarWithIndent>
            </IndentContainer>
        </DefaultPopup>
    );
};

export default AddRouterPopup;
